<template>
  <v-flex xs12 sm8 md4>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-form ref="loginForm" lazy-validation @submit.prevent="login">
        <v-card-text>
          <v-text-field
            prepend-icon="person"
            name="username"
            label="Username"
            type="text"
            v-model="username"
            v-validate="'required'"
            data-vv-as="Username"
            :error-messages="errors.collect('username')"
            required
          ></v-text-field>
          <v-text-field
            prepend-icon="lock"
            name="password"
            label="Password"
            id="password"
            type="password"
            v-validate="'required'"
            data-vv-as="Password"
            v-model="password"
            :error-messages="errors.collect('password')"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit">Login</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  components: {},
  methods: {
    login: function() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          let username = this.username;
          let password = this.password;
          this.$store
            .dispatch("base/login", { username, password })
            .then(() => {
              this.$router.push("/");
            });
        }
      });
    }
  }
};
</script>
